module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_yoso_location@2x-7f37ca5d8b303caf9958b7270d08e019.webp";